export default __webpack_public_path__ + "static/media/45-WEF.5c2ae88a.jpg";